export default __webpack_public_path__ + "static/media/logo.86479052.svg";